import React, { useState, useEffect, lazy, Suspense } from 'react'
import PostLogin from '../../layout/postLogin'
import { Wrapper } from './style'
import { LoaderDots } from '../../components'
import { NAME_VERBATIM_MANAGEMENT } from '../../constants'
import ColumnSection from './components/columnSection'

const Filter = lazy(() => import('./components/filter'))
const Grid = lazy(() => import('./components/grid'))

const VerbatimManagement = () => {
  const [gridData, setGridData] = useState()
  const [loader, setLoader] = useState(false)
  const [columnData, setColumnData] = useState([])

  const loadFilterData = (filterParamData) => {
    setGridData(filterParamData)
  }

  useEffect(() => {
    document.title = NAME_VERBATIM_MANAGEMENT
  }, [])

  return (
    <PostLogin pageTitle={NAME_VERBATIM_MANAGEMENT}>
      <Wrapper>
        <Suspense fallback={<LoaderDots />}>
          <Filter expanded={true} onChange={loadFilterData} onChangeLoader={bool => setLoader(bool)} />
        </Suspense>
        <ColumnSection expanded={true} onChange={d => setColumnData(d)} />
        {columnData?.length > 0 && gridData?.length > 0 && <Suspense fallback={<LoaderDots />}>
          <Grid gridData={gridData} isLoading={loader} columnData={columnData} />
        </Suspense>}
        {loader && <LoaderDots overlay={true} />}
      </Wrapper>
    </PostLogin>
  )
}

export default VerbatimManagement
